import { inject } from '@angular/core';
import { CanActivateFn, NavigationExtras, Router } from '@angular/router';
import { AbilityService } from '../services/ability.service';
import { map } from 'rxjs';
import {
  AbilityAction,
  AbilitySubject,
} from '@kinet-open-network/shared/data-access/model';

export interface CanGuardOptions {
  returnTo?: any[] | any;
  returnToExtras?: NavigationExtras;
}

export const canGuard = (
  action: AbilityAction,
  subject: AbilitySubject,
  options?: CanGuardOptions
): CanActivateFn => {
  return (route, state) => {
    const abilityService = inject(AbilityService);
    const router = inject(Router);

    return abilityService.ability$.pipe(
      map((ability) => ability.can(action, subject)),
      map((can) => {
        if (!can) {
          return router.createUrlTree(
            options?.returnTo || ['/forbidden'],
            options?.returnToExtras
          );
        }

        return true;
      })
    );
  };
};
